import $ from 'jquery';

// グローバルメニュー内のサブメニューを開閉
const globalSubmenuAction = () => {
    document.querySelectorAll('.l-header-global-menu-submenu').forEach((submenu) => {
        const button = submenu.closest('.l-header-global-menu__item').querySelector(':scope > a');
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const isShow = e.currentTarget.hasAttribute('data-open');
            if (isShow) {
                delete e.currentTarget.dataset.open;
            } else {
                document.querySelectorAll('.l-header-global-menu__item > a').forEach((button) => {
                    delete button.dataset.open;
                });
                e.currentTarget.dataset.open = '';
            }
            return false;
        });
    });

    // overlayクリックでメニューを閉じる
    document.querySelector('.l-header-global-menu-overlay').addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.querySelector('.l-header-global-menu [data-open]')
        if (target !== null) {
            delete target.dataset.open;
        }
    });
}

const modalMenuAction = () => {
    const menuObj = document.querySelector('.l-header-modal-menu');
    document.querySelector('.l-header .c-buttons-global-menu').addEventListener('click', (e) => {
        e.preventDefault();
        const isShow = menuObj.hasAttribute('data-open');
        if (isShow) {
            delete menuObj.dataset.open;
        } else {
            menuObj.dataset.open = '';
        }
    });

    menuObj.querySelector('.c-buttons-close').addEventListener('click', (e) => {
        e.preventDefault();
        delete menuObj.dataset.open;
    });
}

const main = () => {
    if (document.querySelector('.l-header') === null) return;
    globalSubmenuAction();
    modalMenuAction();
}

export default main;
